import { Box, SimpleGrid, Skeleton } from "@chakra-ui/react";

export const LoadingState = () => (
    <Box pt={1} pb={[2, 4]}>
        <Skeleton h={3} mt={4} />
        <SimpleGrid columns={[2, 4]}>
            {[1, 2, 3, 4].map(key => (
                <Skeleton key={key} w={10} h="12px" mt={[0.5, 2]} mx="auto" />
            ))}
        </SimpleGrid>
    </Box>
);
